import { DialogActions, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PickersActionBarProps } from '@mui/x-date-pickers';
import { ReactElement } from 'react';

import { PoolButton } from '../buttons';

export const PoolDatePickerActionBar = (props: PickersActionBarProps): ReactElement => {
    const { onAccept, onClear, actions, className } = props;

    return (
        <DialogActions className={className}>
            <Stack direction="row-reverse" justifyContent="space-between" sx={{ width: '100%' }}>
                {actions?.includes('accept') && (
                    <PoolButton onClick={onAccept} color="primary">
                        <FormattedMessage id="app.common.ok" />
                    </PoolButton>
                )}
                {actions?.includes('clear') && (
                    <PoolButton onClick={onClear} color="primary" variant="text">
                        <FormattedMessage id="app.common.delete" />
                    </PoolButton>
                )}
            </Stack>
        </DialogActions>
    );
};
